import { useMemo, useRef, useState, forwardRef } from 'react';
import { Image, Group } from 'react-konva';

function ShadowImage({ stageRef, src, intensity, gamma, backColor }, imageRef) {
  const innerRef = useRef();
  const [position, setPosition] = useState({
    x: stageRef.current?.getWidth() / 2,
    y: stageRef.current?.getHeight() / 2,
  });
  const backgroundImage = useMemo(() => {
    const normalizedImage = new window.Image();
    const shadowImage = new window.Image();
    shadowImage.crossOrigin = 'Anonymous';
    shadowImage.src = src;
    shadowImage.addEventListener('load', () => {
      const padding = 0;
      let w = shadowImage.width;
      let h = shadowImage.height;
      const targetW = stageRef.current.getWidth() - (2 * padding);
      const targetH = stageRef.current.getHeight() - (2 * padding);
      const widthFit = targetW / w;
      const heightFit = targetH / h;
      // compute a scale for best fit and apply it
      const scale = (widthFit > heightFit) ? heightFit : widthFit;

      w = parseInt(w * scale, 10);
      h = parseInt(h * scale, 10);
      imageRef.current.setScale({
        x: scale,
        y: scale,
      });
      setPosition({
        x: (stageRef.current.getWidth() - w) / 2,
        y: (stageRef.current.getHeight() - h) / 2,
      });
      const canvas = document.createElement('canvas');
      canvas.width = shadowImage.width;
      canvas.height = shadowImage.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(shadowImage, 0, 0);
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      for (let i = 0; i < imgData.data.length; i += 4) {
        const shadowR = imgData.data[i];
        const shadowB = imgData.data[i + 1];
        const shadowG = imgData.data[i + 2];
        imgData.data[i] = Math.max(((backColor.r / 255) - (shadowR / 255) ** gamma * intensity), 0) * 255;
        imgData.data[i + 1] = Math.max(((backColor.g / 255) - (shadowB / 255) ** gamma * intensity), 0) * 255;
        imgData.data[i + 2] = Math.max(((backColor.b / 255) - (shadowG / 255) ** gamma * intensity), 0) * 255;
        imgData.data[i + 3] = Math.max(((shadowR / 255) ** gamma * intensity), 0) * 255;
      }
      ctx.putImageData(imgData, 0, 0);
      normalizedImage.src = canvas.toDataURL();
      normalizedImage.addEventListener('load', () => {
        if (innerRef.current) {
          innerRef.current.getLayer().draw();
        }
      });
    });
    return normalizedImage;
  }, [src, intensity, gamma, backColor]);

  return (
    <>
      <Group
        ref={ imageRef }
        x={ position.x }
        y={ position.y }
      >
        <Image
          ref={ innerRef }
          image={ backgroundImage }
        />
      </Group>
    </>
  );
}

export default forwardRef(ShadowImage);
